import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends Controller {
  static targets = ['button', 'label', 'spinner']

  connect () {
    this.onFetchError = this.onFetchError.bind(this)
    document.addEventListener('turbo:fetch-request-error', this.onFetchError)
  }

  disconnect () {
    document.removeEventListener('turbo:fetch-request-error', this.onFetchError)
  }

  async start (event) {
    event.preventDefault()
    event.stopPropagation()

    if (!this.hasButtonTarget || this.buttonTarget.dataset.loading === 'true') {
      return
    }

    const url = this.buttonTarget.href
    this.setLoading(true)

    try {
      const response = await window.fetch(url, {
        credentials: 'same-origin',
        headers: {
          Accept: 'text/vnd.turbo-stream.html'
        }
      })

      if (!response.ok) throw new Error(`Load more request failed (${response.status})`)

      Turbo.renderStreamMessage(await response.text())
    } catch (error) {
      if (this.hasButtonTarget) this.setLoading(false)
      if (process.env.NODE_ENV !== 'production') console.error(error)
    }
  }

  onFetchError () {
    if (this.hasButtonTarget) this.setLoading(false)
  }

  setLoading (loading) {
    this.buttonTarget.dataset.loading = loading ? 'true' : 'false'
    this.buttonTarget.classList.toggle('load-more-btn--loading', loading)
    this.buttonTarget.setAttribute('aria-busy', loading ? 'true' : 'false')

    if (this.hasLabelTarget) this.labelTarget.classList.toggle('hidden', loading)
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.toggle('hidden', !loading)
  }
}
